<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <apexchart type="line" height="310" :options="chartOptions" :series="series" />
</template>

<script>
export default {
  name: "Tests",
  data: () => ({
    series: [
      {
        name: "series1",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      colors: ["#e91e63", "#A300D6", "#008FFB", "#F86624", "#d6c51b"],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      legend: {
        show: true,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      markers: {
        size: 0
      },
      xaxis: {
        type: "datetime",
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      },
      tooltip: {
        x: {
          show: true,
          format: "dd MMM"
        }
      }
    }
  }),
  methods: {
    loadInterventions(data) {
      //check for selected graph
      var annots = [];

      //loop through data
      for (var i = 0; i < data.length; i++) {
        var interv = data[i];

        annots.push({
          x: this.$moment(interv.date, "DD/MM/YYYY")
            .add(10, "hours")
            .toDate()
            .getTime(),
          strokeDashArray: 0,
          borderColor: "#05976e",
          label: {
            borderColor: "#05976e",
            // orientation: "horizontal",
            style: {
              color: "#fff",
              background: "#05976e",
              fontSize: "13px"
            },
            text: interv.intervention
          }
        });
      }

      //set the graph
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          annotations: {
            xaxis: annots
          }
        }
      };
    },
    loadCases(data) {
      this.series[0].data = [];

      var vals = [];

      var dates = [];
      //first get all the distinct dates
      dates = Array.from(new Set(data.map(cas => cas.date))).map(date => {
        return date;
      });

      //loop through all the dates
      for (var i = 0; i < dates.length; i++) {
        var thisDate = dates[i];

        var match = data.find(c => c.date === thisDate && c.region === "National")
        var tests = match.tests*1;

        //push to array
        vals.push([
          this.$moment(thisDate, "DD/MM/YYYY")
            .add(10, "hours")
            .toDate(),
          tests
        ]);
      }

      //set the graph data
      this.series = [{ name: "Tests", data: vals }];
    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        };
      });
    }
  }
};
</script>
